import React from 'react';
import { Tooltip } from './Tooltip';

export type TableTooltipProps = {
  children: React.ReactElement;
  value: string;
  description?: string | string[];
  disabled?: boolean;
  delay?: number;
};

export const TableTooltip: React.FC<TableTooltipProps> = ({
  children,
  value,
  description,
  disabled = false,
  delay = 1000,
}) => {
  return disabled || !value ? (
    <>{children}</>
  ) : (
    <Tooltip
      showArrow={true}
      placement={'bottom'}
      enterDelay={delay}
      enterTouchDelay={delay}
      enterNextDelay={delay}
      variant="dark"
      title={value}
      description={description}
    >
      <span>{children}</span>
    </Tooltip>
  );
};
